import { gql } from '@apollo/client';

/**
 * Queue a portfolio's analytics — risk, attribution, exposures, goal progress —
 * and, once they finish, its review, the client's review and brief, action
 * items and the gap analysis.
 *
 * `queue: true` is always sent from the UI: the call returns at once with
 * `{ success, queued, portfolio_symbol }` (a JSON scalar, no subselection) and
 * the work is followed through getTriggeredEvents. Without it the request
 * would hold open for the whole analysis.
 *
 * Sent as the signed-in advisor, not on a client's behalf, so the job is the
 * advisor's own and shows in their tracker whichever client's screen is open.
 */
export const RUN_PORTFOLIO_ANALYTICS = gql`
  mutation RunPortfolioAnalytics($securitySymbol: String!, $queue: Boolean) {
    runPortfolioAnalytics(securitySymbol: $securitySymbol, queue: $queue)
  }
`;

/**
 * Take a queued job off the queue. Works only while it is WAITING — a RUNNING
 * job cannot be stopped, and `error` says so.
 */
export const CANCEL_TRIGGERED_EVENT = gql`
  mutation CancelTriggeredEvent($kind: String!, $key: String!) {
    cancelTriggeredEvent(kind: $kind, key: $key) {
      state
      error
    }
  }
`;
